import { API_MENU } from '../constants/api';
import request from './api';

import { normalizeMenus, normalizeMenu } from './normalizeResponse';

export const getDayMenu = () =>
  request(`${API_MENU}menu/weeklyMenus/dailyMenu`).then(response =>
    normalizeMenu(response)
  );

export const getWeeklyMenu = () =>
  request(`${API_MENU}menu/weeklyMenus/currentWeeklyMenu`).then(response =>
    normalizeMenus(response)
  );
